/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, from: NonNullable<unknown>, to: NonNullable<unknown> }} Chat_Connector_Preview_ChangeInputs */



/**
* | output |
* | --- |
* | "{label}: {from} → {to}" |
*
* @param {Chat_Connector_Preview_ChangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_connector_preview_change = /** @type {((inputs: Chat_Connector_Preview_ChangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Connector_Preview_ChangeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.label}: ${i?.from} → ${i?.to}`)
	return /** @type {LocalizedString} */ (`${i?.label}: ${i?.from} → ${i?.to}`)
});